'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _epochToDate = require('./epochToDate');

var _epochToDate2 = _interopRequireDefault(_epochToDate);

var _dateToDateString = require('./dateToDateString');

var _dateToDateString2 = _interopRequireDefault(_dateToDateString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var epoch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return (0, _dateToDateString2.default)((0, _epochToDate2.default)(epoch));
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/epochToDateString.js
// module id = 57
// module chunks = 0